/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { isEqual } from '@yk-component/yk-util'
import Search from '../search'
import Option from './Option'
import './options.css'
import { DAC } from '../interface'
import { SelectSingleProps } from './interface'
import colorText from '../uitls/colorText'

const SingleOptions = (props: SelectSingleProps) => {
  const {
    value,
    data = [],
    className,
    onChange,
    header,
    footer,
    clearText,
    disabled,
    readonly,
    hasSearch,
    isEqualFn = isEqual,
    renderEmpty,
    searchOptions,
    onSearch,
    searchData,
    loading,
    renderLoading,
  } = props

  const [searchKey, setSearchKey] = useState('')
  const [searchResult, setSearchResult] = useState<DAC.OptionItem<string>[]>(
    [],
  )

  useEffect(() => {
    if (!searchKey || searchData) return
    const find = (
      key: string,
      options: DAC.OptionItem<string>[] = [],
    ): DAC.OptionItem<string>[] => {
      const items = []
      for (const item of options) {
        if (item.label.includes(key) && !(readonly?.(item) || item.readonly)) {
          items.push(item)
          // eslint-disable-next-line no-continue
          continue
        }
      }
      return items
    }
    const _searchResult = find(searchKey, data as DAC.OptionItem<string>[])
    setSearchResult(_searchResult)
  }, [searchKey, data])

  return (
    <div className={classNames('zySelect', className)}>
      {header}
      {hasSearch && (
        <Search
          value={searchKey}
          onChange={(ev) => {
            setSearchKey(ev.value)
            onSearch?.(ev.value)
          }}
          wrapClassName="zySelectSearch"
          placeholder="请输入关键词"
          {...(typeof searchOptions === 'function'
            ? searchOptions(searchKey, setSearchKey)
            : searchOptions)}
        />
      )}
      {loading ? (
        renderLoading?.() || (
          <div className="zySelectLoading">
            <div className="zySelectLoader" />
            <div>加载中...</div>
          </div>
        )
      ) : searchKey ? (
        <div className="zySelectSearchResult">
          {(searchData ? searchData(searchKey) : searchResult).length
            ? (searchData ? searchData(searchKey) : searchResult).map((m) => {
              return (
                <Option
                  key={m.value}
                  active={isEqualFn(value, m.value)}
                  disabled={disabled?.(m) || m.disabled}
                  readonly={readonly?.(m) || m.readonly}
                  onClick={(ev) => {
                    onChange?.({
                      value: m.value,
                      option: m,
                      event: ev,
                    })
                  }}
                >
                  {colorText(searchKey, m.label)}
                </Option>
              )
            })
            : renderEmpty?.() || (
            <div className="zySelectSearchEmpty">暂无相关搜索结果</div>
            )}
        </div>
      ) : (
        <div className="zySelectOptionsWrap">
          <div className={classNames('zySelectOptions')}>
            {clearText !== false ? (
              <Option
                active={(value ?? undefined) === undefined}
                onClick={(ev) => onChange?.({ value: undefined, event: ev })}
              >
                {clearText || '不限'}
              </Option>
            ) : null}
            {data.map((item, index) => {
              if (item.children) {
                return (
                  <>
                    {item.label && (
                      <div key={item.value} className="zySelectOptionsGroup">{item.label}</div>
                    )}
                    {item.children.map((groupItem) => {
                      return (
                        <Option
                          key={groupItem.value}
                          active={isEqualFn(value, groupItem.value)}
                          disabled={disabled?.(groupItem) || groupItem.disabled}
                          readonly={readonly?.(groupItem) || groupItem.readonly}
                          onClick={(ev) => {
                            onChange?.({
                              value: groupItem.value,
                              option: groupItem,
                              event: ev,
                            })
                          }}
                        >
                          {groupItem.label}
                        </Option>
                      )
                    })}
                    {index !== data.length - 1 && (
                      <div className="zySelectOptionsGroupDivide" />
                    )}
                  </>
                )
              }

              return (
                <Option
                  key={item.value}
                  active={isEqualFn(value, item.value)}
                  disabled={disabled?.(item) || item.disabled}
                  readonly={readonly?.(item) || item.readonly}
                  onClick={(ev) => {
                    onChange?.({
                      value: item.value,
                      option: item,
                      event: ev,
                    })
                  }}
                >
                  {item.label}
                </Option>
              )
            })}
          </div>
        </div>
      )}
      {footer}
    </div>
  )
}

export default SingleOptions
